import querystring from 'querystring';
import { extend } from 'lodash';

import { Params } from './types';

const makeQueryString = (oldParams: Params, mergeParams?: Params) => {
  const newParams = extend({}, oldParams, mergeParams);
  return querystring.stringify(newParams);
};

export default makeQueryString;
